import React, { useState } from "react";
import { Chart } from "primereact/chart";
import { Button } from "primereact/button";
import ChartDivider from "../../ChartDivider";
import ChartSkeleton from "../../../Skeletons/ChartSkeleton";
import { getDayOfWeekChartOptions } from "../../../../utils/chartOptions/dashboard/amount";
const DayOfWeek = React.memo(function DayOfWeek(props) {
  const options = getDayOfWeekChartOptions(
    props?.chartData,
    props?.activeButtonDayOfWeek,
  );

  const handleClick = (label) => props?.setActiveButtonDayOfWeek(label);

  return (
    <div className="mt-4" style={{ maxWidth: "100%" }}>
      <div className="mb-4">
        <h5 className="fw-bold mb-1 text-start">
          <span>Day of Week</span>
          <div
            className="d-flex align-items-center gap-2"
            style={{ float: "right" }}
          >
            <Button
              label="% of Total"
              className={`px-3 py-2 fw-bold fs-6 ${
                props?.activeButtonDayOfWeek === "% OF TOTAL"
                  ? "btn-primary text-white"
                  : "btn-light text-dark"
              }`}
              onClick={() => handleClick("% OF TOTAL")}
              style={{
                borderRadius: "10px",
                border: "none",
                height: "25px",
                backgroundColor:
                  props?.activeButtonDayOfWeek === "% OF TOTAL"
                    ? "#002D42"
                    : "#E0E0E0",
              }}
            />
            {/* <Button
              label={props?.activeTag === "OZ" ? "# of Ounces" : "# of Grams"}
              className={`px-3 py-2 fw-bold fs-6 ${
                props?.activeButtonDayOfWeek ===
                `${props?.activeTag === "OZ" ? "# OF OUNCES" : "# OF GRAMS"}`
                  ? "btn-primary text-white"
                  : "btn-light text-dark"
              }`}
              onClick={() =>
                handleClick(
                  `${props?.activeTag === "OZ" ? "# OF OUNCES" : "# OF GRAMS"}`,
                )
              }
              style={{
                borderRadius: "10px",
                border: "none",
                height: "25px",
                backgroundColor:
                  props?.activeButtonDayOfWeek ===
                  `${props?.activeTag === "OZ" ? "# OF OUNCES" : "# OF GRAMS"}`
                    ? "#002D42"
                    : "#E0E0E0",
              }}
            /> */}
          </div>
        </h5>
        <p
          className="mb-0 text-start fw-bold fs-12 py-3"
          style={{ color: "#6c757d" }}
        >
          Average {props?.activeTag === "OZ" ? "ounces" : "grams"} used per
          occasion by day of week
        </p>
        <div className="col-12">
          {!props?.dayOfWeekLoader ? (
            <Chart
              type="bar"
              data={props?.chartData}
              options={options}
              redraw={(props?.isFilterHide || props?.showSidebar).toString()}
            />
          ) : (
            <ChartSkeleton />
          )}
        </div>
        <ChartDivider />
      </div>
    </div>
  );
});

export default DayOfWeek;
